"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locationRepository = void 0;
const services_1 = require("@hc-frontend/services");
const utils_1 = require("@hc-frontend/utils");
const ramda_1 = require("ramda");
const __1 = require("../..");
const createZipLocations = (0, ramda_1.map)((0, ramda_1.applySpec)({
    zip: (0, ramda_1.prop)('zipCode'),
    stateAcronym: (0, ramda_1.prop)('stateAcronym'),
    stateName: (0, ramda_1.prop)('stateName'),
    city: (0, ramda_1.prop)('city'),
    county: (0, ramda_1.prop)('countyName'),
    type: (0, ramda_1.always)(__1.LocationType.ZIP),
}));
const createGlobalLocation = (0, ramda_1.applySpec)({
    zip: (0, ramda_1.prop)('postal'),
    stateAcronym: (0, ramda_1.prop)('region_code'),
    stateName: (0, ramda_1.prop)('region'),
    city: (0, ramda_1.prop)('city'),
    county: (0, ramda_1.prop)('county'),
    country: (0, ramda_1.prop)('country'),
    type: (0, ramda_1.always)(__1.LocationType.GEO),
});
const locationRepository = {
    async fetchLocationByIp() {
        const locationInformation = await (0, services_1.fetchLocationByIpService)();
        if ((0, utils_1.isDefined)(locationInformation))
            return createGlobalLocation(locationInformation);
        return null;
    },
    async fetchAllLocationsByZip(zip) {
        const locationInformation = await (0, services_1.fetchAllLocationsByZipService)(zip);
        return locationInformation ? createZipLocations(locationInformation) : null;
    },
};
exports.locationRepository = locationRepository;
//# sourceMappingURL=location-repository.js.map